import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Filter1Icon from '@material-ui/icons/Filter1';
import Filter2Icon from '@material-ui/icons/Filter2';
import Filter3Icon from '@material-ui/icons/Filter3';
import Filter4Icon from '@material-ui/icons/Filter4';
import PersonIcon from '@material-ui/icons/Person';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import EventIcon from '@material-ui/icons/Event';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LockIcon from '@material-ui/icons/Lock';
import { useHistory } from "react-router-dom";
import * as AuthActions from "../../store/actions/auth";
import { Divider } from '@material-ui/core';
import { useFeature } from "../../featureGating/featureGating";

const useStyles = makeStyles((theme) => ({
  listText: {
    paddingLeft: 5,
    fontSize: '0.85rem',
    [theme.breakpoints.down('lg')]: { fontSize: '0.82rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.78rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.74rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.64rem' },
  },
}));

export function MainListItems_Clinics({ open, onVideocallClick, onNotificationsClick, onMessagesClick }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const pathname = window.location.pathname;
  const navigate = (path) => {
    if (pathname !== path) {
      history.push(path);
    }
  };

  const canCalendar = useFeature('basic_calendar');
  const canVideo = useFeature('video_consultations');
  const canMessages = useFeature('secure_chat');
  const LockAdornment = () => (
    <LockIcon style={{ color: '#FF7F27', fontSize: 'clamp(14px, 0.9vw, 16px)', marginLeft: 4 }} />
  );

  const handleLogout = async () => {
    try {
      await dispatch(AuthActions.logout());
    } catch (e) {
      dispatch({ type: AuthActions.LOGOUT });
    }
    window.location.replace('/');
  };

  const [notificationsAnchorEl, setNotificationsAnchorEl] = useState(null);
  const handleNotificationsOpen = (e) => setNotificationsAnchorEl(e.currentTarget);
  const handleNotificationsClose = () => setNotificationsAnchorEl(null);

  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const handleProfileOpen = (e) => setProfileAnchorEl(e.currentTarget);
  const handleProfileClose = () => setProfileAnchorEl(null);

  const handleMessagesClick = (e) => {
    if (onMessagesClick) onMessagesClick(e);
    window.dispatchEvent(
      new CustomEvent('chat:open-messages', { detail: { anchorEl: e.currentTarget } })
    );
  };

  return (
    <div>
      <Tooltip title="My clinic" placement="right" disableHoverListener={open}>
        <ListItem button onClick={() => navigate('/my_clinic_account')} style={{color: "#002D55", backgroundColor: pathname === '/my_clinic_account' ? '#F2F4F7' : '#FFFFFF'}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <DashboardIcon style={{color: "#002D55", backgroundColor: pathname === '/my_clinic_account' ? '#F2F4F7' : '#FFFFFF', fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="My clinic" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      </Tooltip>
      <Tooltip title="Patients" placement="right" disableHoverListener={open}>
        <ListItem button onClick={() => navigate('/admin_dashboard')} style={{color: "#002D55", backgroundColor: pathname === '/admin_dashboard' ? '#F2F4F7' : '#FFFFFF'}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <PersonIcon style={{color: "#002D55", backgroundColor: pathname === '/admin_dashboard' ? '#F2F4F7' : '#FFFFFF', fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Patients" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      </Tooltip>
      <Tooltip title={canCalendar ? "Calendar" : "Upgrade to subscription to activate this feature"} placement="right" disableHoverListener={open}>
        <span>
          <ListItem button disabled={!canCalendar} onClick={canCalendar ? () => navigate('/clinic_calendar') : undefined} style={{color: "#002D55", backgroundColor: pathname === '/clinic_calendar' ? '#F2F4F7' : '#FFFFFF'}}>
            <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
              <EventIcon style={{color: "#002D55", backgroundColor: pathname === '/clinic_calendar' ? '#F2F4F7' : '#FFFFFF', fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
            </ListItemIcon>
            {open && <ListItemText primary="Calendar" primaryTypographyProps={{ className: classes.listText }} />}
            {!canCalendar && open && <LockAdornment />}
          </ListItem>
        </span>
      </Tooltip>
      <Tooltip title={canVideo ? "Video call" : "Upgrade to subscription to activate this feature"} placement="right" disableHoverListener={open}>
        <span>
          <ListItem button disabled={!canVideo} onClick={canVideo ? onVideocallClick : undefined} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
            <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
              <VideoCallIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
            </ListItemIcon>
            {open && <ListItemText primary="Video call" primaryTypographyProps={{ className: classes.listText }} />}
            {!canVideo && open && <LockAdornment />}
          </ListItem>
        </span>
      </Tooltip>
      <Tooltip title={canMessages ? "Messages" : "Upgrade to subscription to activate this feature"} placement="right" disableHoverListener={open}>
        <span>
          <ListItem button disabled={!canMessages} onClick={canMessages ? handleMessagesClick : undefined} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
            <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
              <MailOutlineIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
            </ListItemIcon>
            {open && <ListItemText primary="Messages" primaryTypographyProps={{ className: classes.listText }} />}
            {!canMessages && open && <LockAdornment />}
          </ListItem>
        </span>
      </Tooltip>
      <Tooltip title="Notifications" placement="right" disableHoverListener={open}>
        <ListItem button onClick={handleNotificationsOpen} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <NotificationsIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Notifications" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      </Tooltip>
      <Menu
        anchorEl={notificationsAnchorEl}
        keepMounted
        open={Boolean(notificationsAnchorEl)}
        onClose={handleNotificationsClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { borderRadius: 14, minWidth: 'clamp(120px, 10vw, 160px)' } }}
      >
        <div style={{ padding: '8px 12px 6px 12px', borderBottom: '1px solid #eee', fontWeight: 600, fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)' }}>Notifications</div>
        <MenuItem disabled style={{ fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)' }}>No notifications</MenuItem>
      </Menu>
      <Divider style={{marginTop: '6px', marginBottom: '6px'}}/>
      <Tooltip title="Logout" placement="right" disableHoverListener={open}>
        <ListItem button onClick={handleProfileOpen} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <VpnKeyIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Logout" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      </Tooltip>
      <Menu
        anchorEl={profileAnchorEl}
        keepMounted
        open={Boolean(profileAnchorEl)}
        onClose={handleProfileClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { borderRadius: 14, minWidth: 'clamp(120px, 10vw, 160px)' } }}
      >
        <MenuItem onClick={() => { handleProfileClose(); handleLogout(); }} style={{ fontSize: 'clamp(0.72rem, 0.8vw, 0.875rem)', padding: '6px 16px' }}>Logout</MenuItem>
      </Menu>
    </div>
  );
}







